import { useLocation } from 'react-router';
import { useAsync } from 'react-use';

import { identityApiRef, useApi } from '@backstage/core-plugin-api';

import { TomtomLabApi } from '../../api';
import { Assessment } from '../../types';

export const useAssessment = (
  tomtomLabApi: TomtomLabApi,
  type?: String,
  ideaId?: number,
): { assessment?: Assessment | null | undefined; userRef?: string } => {
  const location = useLocation();

  const identityApi = useApi(identityApiRef);

  let ideaIdParam = ideaId;
  if (!ideaIdParam || isNaN(ideaIdParam)) {
    const paths = location.pathname.split('/');
    ideaIdParam = Number(paths[paths.length - 1]);
  }

  const { value } = useAsync(async () => {
    const userRef =
      (await identityApi.getBackstageIdentity()).userEntityRef ?? '';
    if (ideaIdParam && !isNaN(ideaIdParam)) {
      let assessment;
      if (type === 'JURY' && userRef && userRef !== '') {
        assessment = await tomtomLabApi.getJuryAssessment(ideaIdParam, userRef);
      }
      if (type === 'SELF') {
        assessment = await tomtomLabApi.getSelfAssessment(ideaIdParam);
      }

      if (assessment) {
        return {
          assessment: assessment as Assessment,
          userRef,
        };
      }
    }
    return {
      assessment: null,
      userRef,
    };
  });

  return {
    ...value,
  };
};
